import "./MyModal.css"

import { Modal } from "react-bootstrap"
import { IoMdCloseCircleOutline } from "react-icons/io"

import Box from "@/components/Box/Box"
import type { Modals } from "@/constants/modals"
import { useStore } from "@/zustand/store"

interface MyModalProps {
  modalName: Modals
  title: React.ReactNode
  isOpen?: boolean
  setIsOpen?: (isOpen: boolean) => void
  children: React.ReactNode
  size?: "sm" | "lg" | "xl"
  titleClassname?: string
  noPadding?: boolean
  onClose?: () => void
}

export default function MyModal({
  modalName,
  isOpen,
  setIsOpen,
  children,
  size,
  title,
  titleClassname,
  noPadding,
  onClose,
}: MyModalProps) {
  const zustandIsOpen = useStore((state) => state.modalsStates[modalName])

  const editModalState = useStore((state) => state.editModalState)

  function closeModal() {
    if (modalName) editModalState(modalName, undefined)
    else if (setIsOpen) setIsOpen(false)

    if (onClose) onClose()
  }

  return (
    <Modal
      centered
      size={size || "xl"}
      show={Boolean(zustandIsOpen) || Boolean(isOpen)}
      onHide={closeModal}
      enforceFocus={false}
    >
      <Box
        title={
          <div className="d-flex align-items-center justify-content-between">
            <div>{title}</div>
            <div className="cursor-pointer" onClick={closeModal}>
              <IoMdCloseCircleOutline size={20} />
            </div>
          </div>
        }
        className="overflow-visible"
        titleClassname={titleClassname}
        noPadding={noPadding}
      >
        {children}
      </Box>
    </Modal>
  )
}
